import { render, staticRenderFns } from "./DeCenterNew.vue?vue&type=template&id=da650f52"
import script from "./DeCenterNew.vue?vue&type=script&lang=js"
export * from "./DeCenterNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports